/** Must match WinIt-backend meta-capi/buildPayload buildEventId(). */
const EVENT_ID_PREFIX = {
  traffic_submit: 'traffic-submit',
  traffic_converted: 'traffic-converted',
  payment_info_saved: 'add-payment-info',
}

export function buildEventId(eventType, subjectId) {
  const prefix = EVENT_ID_PREFIX[eventType]
  if (!prefix) throw new Error(`Unknown CAPI event type: ${eventType}`)
  return `${prefix}:${subjectId}`
}
